<div class="container my-5" *ngIf="!loading">
  <div class="row justify-content-center">
    <h1 class="card-title text-center mb-5">Your Profile</h1>
    <div class="col-md-6">
      <div class="card shadow-lg border-0 rounded-3 p-4">
        <div class="mb-3">
          <label class="fw-semibold" style="color:#0D1B56;">Name</label>
          <div>{{ userProfile.user?.Name || '-' }}</div>
        </div>

        <div class="mb-3">
          <label class="fw-semibold" style="color:#0D1B56;">Email</label>
          <div>{{ userProfile?.email || '-' }}</div>
        </div>

        <div class="mb-3">
          <label class="fw-semibold" style="color:#0D1B56;">Phone Number</label>
          <div>{{ userProfile?.phoneNumber || '-' }}</div>
        </div>

        <div class="mb-3">
          <label class="fw-semibold" style="color:#0D1B56;">Date of Birth</label>
          <div>{{ userProfile?.dob | date : 'dd-MM-yyyy' }}</div>
        </div>

        <div class="mb-3">
          <label class="fw-semibold" style="color:#0D1B56;">Gender</label>
          <div>{{ userProfile?.gender || '-' }}</div>
        </div>

        <div class="mb-3">
          <label class="fw-semibold" style="color:#0D1B56;">Aspiration</label>
          <div>{{ userProfile?.hasAspiration ? 'Yes' : 'No' }}</div>
        </div>

        <div class="mb-3" *ngIf="userProfile?.hasAspiration">
          <label class="fw-semibold" style="color:#0D1B56;">Aspiration Type</label>
          <div>{{ userProfile?.aspirationType || 'No' }}</div>
        </div>

        <div class="mb-3" *ngIf="userProfile?.aspirationType === 'Other'">
          <label class="fw-semibold" style="color:#0D1B56;">Aspiration Description</label>
          <div>{{ userProfile?.aspirationText || '-' }}</div>
        </div>

        <div class="d-grid">
          <button type="submit" class="btn btn-primary" (click)="goToLinkRoute('user-dashboard')">
            <i class="bi me-2"></i> Back to Dashboard
          </button>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="text-center mt-5" *ngIf="loading">
  <div class="spinner-border"></div>
</div>